import { Component, HostBinding, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { WarehousesTooltipComponent } from "../warehouses-tooltip/warehouses-tooltip.component";
import { ListExpandDialogComponent } from "./list-expand-dialog/list-expand-dialog.component";
import { Subject } from "rxjs";

@Component({
  selector: "app-simple-list-cell-renderer",
  templateUrl: "./simple-list-cell-renderer.component.html",
  styleUrls: ["./simple-list-cell-renderer.component.scss"],
})
export class SimpleListCellRendererComponent  implements OnDestroy{
  params;
  displayArrow:boolean;
  items: { label: string; number: number, up?: boolean, down?: boolean }[]
  list: { label: string; priceProp: number }[];
  seasonalSalesList:any;
  salesList:{ label: string; number?: number, text?:string, tooltip?:string }[]=[];
  isSeasonalSales:boolean=false;
  seasonalVelocity;
  isVelocity:boolean = false;
  @HostBinding('class') class: boolean;
  value;
  private destroy$ = new Subject<void>();
  constructor(private dialog: MatDialog) {}

  agInit(params: any): void {
    this.params = params;
    this.displayArrow = this.params['displayArrow'] === false ? false : true;
    this.list = this.params["props"];
    this.isVelocity = this.params["isVelocity"]
    if(this.params.isWhsTooltip || this.params.isRepWhsTooltip){
      this.value=this.params.value;
    } else  {
    this.isSeasonalSales = this.params["isSeasonalSales"];
    this.seasonalSalesList = this.params["seasonalSales"];
    this.seasonalVelocity = this.params["seasonalVelocity"];
    this.items = this.list.map((item, i) => {
      return {
        label: item.label,
        number: this.params.data[item.priceProp],
        up: this.params.data[item.priceProp] > this.params.data[this.list[i + 1]?.priceProp],
        down: this.params.data[item.priceProp] < this.params.data[this.list[i + 1]?.priceProp],
        displayArrow: this.displayArrow
      }
    })
    if (this.params.class) {
      this.class = this.params.class;
    }
    if(this.seasonalSalesList || this.seasonalVelocity){
      this.bindSeasonalList();
    }
    }
  }

  bindSeasonalList(){
    if(this.isSeasonalSales){
      this.salesList = this.seasonalSalesList?.map((item, i) => {
        return {
          label: item.label,
          number: this.params.data[item.priceProp] ? this.params.data[item.priceProp] : 0
        }
      });
    } else {
      const Velocity90_1yr = this.params.data["Velocity90_1yr"] ? this.params.data["Velocity90_1yr"].toFixed(2) : 0;
      const Velocity90_2yr = this.params.data["Velocity90_2yr"] ? this.params.data["Velocity90_2yr"].toFixed(2) : 0;
      const PctChange1Yr = this.params.data["PctChange1Yr"] ? this.params.data["PctChange1Yr"].toFixed(2) : 0;
      const PctChange2Yr = this.params.data["PctChange2Yr"] ? this.params.data["PctChange2Yr"].toFixed(2) : 0;
      const PurchaseDayVel1yr= this.params.data["PurchaseDayVel1yr"] ? this.params.data["PurchaseDayVel1yr"].toFixed(2) : 0; 
      const PurchaseDayVel2yr= this.params.data["PurchaseDayVel2yr"] ? this.params.data["PurchaseDayVel2yr"].toFixed(2) : 0;
      this.salesList=[
        {
          label: "Last year",
          text:  Velocity90_1yr +' ' + PctChange1Yr,
          tooltip: PurchaseDayVel1yr
        },
        {
          label: "2 years ago",
          text:  Velocity90_2yr +' ' + PctChange2Yr,
          tooltip: PurchaseDayVel2yr
        }
      ];
    }   
  }

  openExpandDialog(event: MouseEvent) {
    event.stopPropagation();
    if(!this.params.data.ReplenishVelocityOrg){
      this.params.data.ReplenishVelocityOrg = this.params.data.ReplenishVelocity;
    }     
    const data={
      items: this.items,
      seasonalValues:this.salesList,
      isSeasonalSales:this.isSeasonalSales,
      seasonalTitle:this.isSeasonalSales ? 'Seasonal sales' : 'Seasonal velocity'
    }
    this.dialog.open(ListExpandDialogComponent, {
      position: this.getDialogPosition(event),
      width: this.isSeasonalSales ? '141px' : this.salesList.length !== 0 ? '170px' :  this.isVelocity ? '150px' : '120px',
      data: this.salesList.length !== 0 ? data : { items: this.items,velocity:this.isVelocity,generalVelocity:this.params.data.ReplenishVelocityOrg },
      backdropClass: ["cdk-overlay-transparent-backdrop", "arrow-backdrop"],
    }).afterClosed().subscribe((res)=>{
       if(res && this.isVelocity){
        if (this.params.callbackFunction) {
          const output = {
            value: res.number ? res.number : res,
            node: this.params.node
          }
          this.params.callbackFunction(output);
         }
       }
    })
  }

  getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 52 + "px",
      top: targetPosision.top + 20 + "px",
    }
  }

  
  openExpandWarehouse(event: MouseEvent){
    event.stopPropagation();
    this.dialog.open(WarehousesTooltipComponent, {
      position: this.getDialogPosition(event),
      width: '220px',
      data: !this.params?.isRepWhsTooltip ? this.params.data.ItemId : {accountSkuId: this.params.data.AccountSkuId},
      backdropClass: ["cdk-overlay-transparent-backdrop", "arrow-backdrop"],
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
